import React, { useContext, useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext, base_url } from "../context/Authcontext";
import '../../src/assets/AdminCss/card.css';
import TopBar from "./components/TopNavbar";
import MarqueeBottom from "./components/MarqueeBottom";
import { useTheme } from "../context/ThemeContext";
import toast from "react-hot-toast";
import LoginReg from "./LoginReg";
import { useMemo } from "react";
import { Spinner } from "react-bootstrap";
import SportFilters from "./components/SportFilters";
import EventCard from "./components/EventCard";
import { matchesFilter } from "../utils/matchFilters";

const formatDate = (dateString) => {

  if (!dateString) return null;

  const dateObj = new Date(dateString);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`; // Only date (YYYY-MM-DD)
};



const compareWithToday = (openDate) => {
  const now = new Date();

  // Get today's date
  const today = formatDate(now);

  // Get tomorrow's date by adding 1 day to the current date
  const tomorrow = formatDate(new Date(now.getTime() + 24 * 60 * 60 * 1000)); // 24 hours in milliseconds

  // Convert openDate string to Date object
  const eventDateObj = new Date(openDate);

  const eventDateFormatted = formatDate(eventDateObj);

  return eventDateFormatted === today || eventDateFormatted === tomorrow;
};

const getMinutesSinceMidnight = (date) => {
  return date.getUTCHours() * 60 + date.getUTCMinutes();
};



const Inplay = ({ data }) => {
  const { isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const [cricket, setCricket] = useState([]);
  const [avail, setAvail] = useState([]);
  const [loading, setLoading] = useState(true);
  const [timeFilter, setTimeFilter] = useState("all");
  const [teamQuery, setTeamQuery] = useState("");
  const [selectedBet, setSelectedBet] = useState(0);
  const [backActive, setbackActive] = useState(0);
  const [layActive, setlayActive] = useState(0);
  const [money, setMoney] = useState(0);
  const [pr, setPr] = useState(0);
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [side, setSide] = useState("");
  const [active, setActive] = useState(false);
  const [selectedMatch, setSelectedMatch] = useState("");
  const [selectionid, setSelectionid] = useState();
  const [runner, setRunner] = useState();
  const [competition, setCompetition] = useState();
  const [eventid, setEventid] = useState();
  const [eventname, setEventname] = useState();
  const [profit, setProfit] = useState(0);
  const [time, setTime] = useState();
  // ✅ NEW STATES
  const [rawMatches, setRawMatches] = useState([]);
  const [marketList, setMarketList] = useState([]);

  const sortMatches = (matches) => {
    return [...matches].sort((a, b) => {

      const aLive = a?.inplay || a?.event?.inPlay || a?.event?.status === "LIVE";
      const bLive = b?.inplay || b?.event?.inPlay || b?.event?.status === "LIVE";

      // 1️⃣ Live matches first
      if (aLive && !bLive) return -1;
      if (!aLive && bLive) return 1;

      // 2️⃣ Then by increasing start time
      const timeA = new Date(a?.event?.openDate).getTime();
      const timeB = new Date(b?.event?.openDate).getTime();

      return timeA - timeB;
    });
  };
  //  const location= useLocation();

  // const [list, setList]= useState(location?.state?.list || 0);


  //  const tabStyle = (index) => ({
  //   padding: "6px 12px",
  //   alignItems: "center",
  //   cursor: "pointer",
  //   flexShrink: 0,
  //   fontWeight: 600,
  //   background: list === index ? "#41a1ef" : "transparent",
  //   color: "#fff",
  //   borderRadius: "2px",
  //   width:'auto'
  // });

  // ✅ STEP 1A: matchData - setRawMatches instead of setCricket
  const matchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(base_url + "/api/webapi/matchapi", {
        headers: { "Content-Type": "application/json" },
      });
      console.log("API Response:", response?.data);
      const data = response?.data?.result?.data || [];
      const allOpenDates = data.map(dta => dta?.event?.openDate);
      const allData = [];
      data.forEach((dta) => {
        if (compareWithToday(dta?.event?.openDate, allOpenDates)) {
          allData.push(dta);
        }
      });
      console.log("Filtered Matches for Today:", allData);
      setRawMatches(allData); // ✅ changed 
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ STEP 1B: footballData - setRawMatches instead of setCricket
  const footballData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(base_url + "/api/webapi/footballapi", {
        headers: { "Content-Type": "application/json" },
      });
      console.log("Football API Response:", response?.data);
      const data = response?.data?.result?.data || [];
      const allOpenDates = data.map(dta => dta?.event?.openDate);
      const allData = [];
      data.forEach((dta) => {
        if (compareWithToday(dta?.event?.openDate, allOpenDates)) {
          allData.push(dta);
        }
      });
      console.log("Filtered Football Matches:", allData);
      setRawMatches(allData); // ✅ changed
    } catch (error) {
      console.error("Football API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ STEP 1C: tennisData - setRawMatches instead of setCricket
  const tennisData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(base_url + "/api/webapi/tennisapi", {
        headers: { "Content-Type": "application/json" },
      });
      console.log("Tennis API Response:", response?.data);
      const data = response?.data?.result?.data || [];
      const allOpenDates = data.map(dta => dta?.event?.openDate);
      const allData = [];
      data.forEach((dta) => {
        if (compareWithToday(dta?.event?.openDate, allOpenDates)) {
          allData.push(dta);
        }
      });
      // console.log("Filtered Tennis Matches:", allData);
      setRawMatches(allData); // ✅ changed
    } catch (error) {
      console.error("Tennis API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ STEP 2: rawMatches changes → getMarkets (no more loop because we don't set rawMatches here)
  useEffect(() => {
    const getMarkets = async () => {
      setLoading(true)
      if (rawMatches.length === 0) return;

      try {

        const eventIds = rawMatches.map(item => item?.event?.id);

        const response = await axios.post(
          `${base_url}/game/kheloyaar/getMarkets`,
          { eventIds }
        );

        const markets = response.data.data || [];

        // 🔥 SORT MATCHES
        const sortedMarkets = sortMatches(markets);

        setMarketList(sortedMarkets);
        setCricket(sortedMarkets);

      } catch (err) {
        console.error("Markets Error:", err);
      } finally {
        setLoading(false);
      }

    };

    getMarkets();

  }, [rawMatches]);

  // ✅ STEP 3: marketList changes → fetchOdds (no more loop because we don't set marketList here)
  useEffect(() => {
    const fetchOdds = async () => {
      if (!marketList || marketList.length === 0) return;
      setLoading(true)
      try {
        const marketIds = marketList.map(item => item.marketId).filter(Boolean);
        const chunks = [];
        for (let i = 0; i < marketIds.length; i += 10) {
          chunks.push(marketIds.slice(i, i + 10));
        }
        const requests = chunks.map(chunk =>
          axios.post(`${base_url}/api/webapi/market/wholeMarket`, {
            marketIds: chunk
          })
        );

        const responses = await Promise.all(requests);

        let allOdds = [];

        responses.forEach(response => {
          const oddsData =
            typeof response.data === "string"
              ? JSON.parse(response.data)
              : response.data;

          const markets = oddsData?.data?.data || [];
          allOdds = [...allOdds, ...markets];
        });
        console.log("Fetched Odds Data:", allOdds);
        setAvail(allOdds);
      } catch (error) {
        console.error("Odds Fetch Error:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchOdds();
  }, [marketList]); // ✅ only marketList — no loop

  const [formData, setFormData] = useState({
    competiton: "",
    eventname: "",
    eventid: 0,
    marketId: "",
    selectionId: 0,
    runnername: "",
    betPrice: 0,
    type: "odds",
    betAmount: 0,
    profit: 0,
    side: "",
    status: 0,
  });

  function formatDate(isoString) {
    const date = new Date(isoString);
    return date.toLocaleString("en-US", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  }

  const handlelayChange = (action) => {
    setSelectedPrice((prev) => {
      let newMoney = prev < 1.01 ? 1.01 : prev;

      if (action === 0) {
        return Math.max(0, (parseFloat(newMoney) - 0.01).toFixed(2));
      } else {
        return (parseFloat(newMoney) + 0.01).toFixed(2);
      }
    });
  };

  const handleChange = (action) => {
    // console.log('act',action);

    setMoney((prevMoney) => {
      let newMoney = prevMoney < 0 ? 0 : prevMoney;

      if (action === 0) {
        return Math.max(0, parseFloat(newMoney) - 100);
      } else {
        return parseFloat(newMoney) + 100;
      }
    });
  };

  const handleBetClick = async (item, index, marketid) => {
    // console.log(item);
    // console.log(index);
    // console.log(marketid);
    try {
      const match = cricket.find((cric) => cric.marketId === marketid);
      const runners = match.runners;
      setEventid(match?.event.id);
      setEventname(match?.event.name);
      setCompetition(match?.competition.name);
      const time = formatDate(match?.event.openDate);
      setTime(time);
      // console.log(match);

      if (index < 2) {
        setSelectionid(runners[0].selectionId);
        setRunner(runners[0].runnerName);
      } else {
        setSelectionid(runners[1].selectionId);
        setRunner(runners[1].runnerName);
      }

      if (item?.type === "Back") {
        // console.log('back called');
        setbackActive(1);
        setlayActive(0);
        setSide(item.type);
        setSelectedBet(index);
        setSelectedPrice(item.price);
        setSelectedMatch(marketid);
      } else if (item?.type === "Lay") {
        // console.log('lay called');
        setlayActive(1);
        setbackActive(0);
        setSide(item.type);
        setSelectedBet(index);
        setSelectedPrice(item.price);
        setSelectedMatch(marketid);
      }
    } catch (err) {
      console.log(err);
    }
  };
  // console.log(selectionid, runner);

  function isTenMinutesRemaining(isoString) {
    const targetTime = new Date(isoString).getTime(); // Convert given time
    const currentTime = new Date().getTime(); // Get current time

    // Calculate the difference in milliseconds
    const timeDifference = targetTime - currentTime;

    // Convert milliseconds to minutes
    const minutesRemaining = timeDifference / (1000 * 60);

    return minutesRemaining > 10;
  }

  const handleSubmit = async () => {
    if (!isAuthenticated) {
      setActive(true);
      return;
    }

    // if(isTenMinutesRemaining(time)){
    //   toast.error('Off Bets! Bets placed only before ten minutes');
    //   return;
    // }

    if (money < 100) {
      toast.error("Bet cant be placed less than min value");
      return;
    }

    if (selectedPrice < 1) {
      toast.error("Bet selectedprice is less");
      return;
    }

    // console.log('form',formData);

    try {
      const response = await axios.post(
        base_url + "/api/webapi/sportsData",
        formData,
        {
          withCredentials: true,
          headers: {
            "content-type": "application/json",
          },
        }
      );

      // console.log('formmatch',response);

      if (response?.data.success) {
        toast.success(response?.data.message);
      } else {
        toast.error(response?.data.message);
      }
      // window.location.reload();
      setbackActive(0);
      setlayActive(0);
    } catch (err) {
      console.log(err);
      toast.error("Failed to place bet");
    }
  };

  const marketMap = useMemo(() => {
    const map = {};
    avail.forEach(m => {
      map[m.marketId] = m;
    });
    return map;
  }, [avail]);

  const handleClick = (item) => {
    // console.log(item);

    sessionStorage.clear();
    sessionStorage.setItem("marketId", item.marketId);
    sessionStorage.setItem("competetionid", item.competition.id);
    sessionStorage.setItem("eventid", item.event.id);
    sessionStorage.setItem("time", item?.event.openDate);
    sessionStorage.setItem("competitionname", item?.competition.name);
    sessionStorage.setItem("eventname", item?.event.name);

    if (item.eventType.name === "Cricket") {
      navigate("/cricketBet");
      sessionStorage.setItem("selectionid1", item?.runners[0].selectionId);
      sessionStorage.setItem("selectionid2", item?.runners[1].selectionId);

      sessionStorage.setItem("runner1", item.runners[0].runnerName);
      sessionStorage.setItem("runner2", item.runners[1].runnerName);
      // console.log(item.runners, item.runners.length);
      if (item?.runners.length === 3) {
        sessionStorage.setItem("selectionid3", item?.runners[2].selectionId);
        sessionStorage.setItem("runner3", item.runners[2].runnerName);
      }
    } else if (item.eventType.name === "Soccer") {
      navigate("/footBAllBet");
      sessionStorage.setItem("selectionid1", item?.runners[0].selectionId);
      sessionStorage.setItem("selectionid2", item?.runners[1].selectionId);
      sessionStorage.setItem("selectionid3", item?.runners[2].selectionId);

      sessionStorage.setItem("runner1", item.runners[0].runnerName);
      sessionStorage.setItem("runner2", item.runners[1].runnerName);
      sessionStorage.setItem("runner3", item.runners[2].runnerName);
    } else if (item.eventType.name === "Tennis") {
      navigate("/tennis");
      sessionStorage.setItem("selectionid1", item?.runners[0].selectionId);
      sessionStorage.setItem("selectionid2", item?.runners[1].selectionId);

      sessionStorage.setItem("runner1", item.runners[0].runnerName);
      sessionStorage.setItem("runner2", item.runners[1].runnerName);

      if (item?.runners.length === 3) {
        sessionStorage.setItem("selectionid3", item?.runners[2].selectionId);
        sessionStorage.setItem("runner3", item.runners[2].runnerName);
      }
    }
  };

  // 1. Fetch matchData only on mount or when `data` changes
  useEffect(() => {
    const fetchData = async () => {
      if (data === 0) {
        await matchData();
      } else if (data === 1) {
        await footballData();
      } else if (data === 2) {
        await tennisData();
      }
    };

    fetchData();
  }, [data]); // Only when 'data' changes

  // 2. When cricket is updated, then call odds API
  // useEffect(() => {
  //   const oddsData = async () => {
  //     if (cricket.length === 0) return;

  //     try {
  //       const marketid = cricket.map((item) => item.marketId);

  //       const response = await axios.post(
  //         `${base_url}/api/webapi/market/wholeMarket`,
  //         marketid,
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           timeout: 10000,
  //         }
  //       );

  //       const result = JSON.parse(response.data); // Remove JSON.parse if response is already JSON
  //       setAvail(result);
  //     } catch (err) {
  //       console.error("Error fetching odds data:", err);
  //     }
  //   };

  //   oddsData();
  // }, [cricket]);

  // 3. Calculate profit separately
  useEffect(() => {
    if (!isNaN(selectedPrice) && !isNaN(money)) {
      const proft =
        parseFloat(selectedPrice) * parseFloat(money) - parseFloat(money);
      setProfit(proft.toFixed(1));
    }
  }, [selectedPrice, money]); // Only update when those change

  // console.log('vall',cricket);

  formData.competiton = competition;
  formData.eventid = eventid;
  formData.eventname = eventname;
  formData.marketId = selectedMatch;
  formData.selectionId = selectionid;
  formData.runnername = runner;
  formData.betPrice = selectedPrice;
  formData.betAmount = money;
  formData.side = side;
  formData.profit = profit;
  // console.log(avail);
  // console.log(avail);

  return (
    <>
      {<LoginReg active={active} setactive={setActive} />}
      <div _ngcontent-jrx-c94="" className="wrap-conatiner">
        <div _ngcontent-jrx-c94="">
          <div
            _ngcontent-jrx-c94=""
            className="section tabs_boxes_section no-pad-bot no-pad-top"
          >

            <div _ngcontent-jrx-c94="" className="">
              <SportFilters
                timeFilter={timeFilter}
                setTimeFilter={setTimeFilter}
                teamQuery={teamQuery}
                setTeamQuery={setTeamQuery}
              />
              <div _ngcontent-jrx-c94="" className="sports-wrapper rb-events">

                {console.log('cricket', cricket)}
                {loading ? (
                  /* Skeletons rather than a spinner on a blank page, so the
                     list holds its shape while the odds arrive. */
                  <>
                    {Array.from({ length: 6 }).map((_, i) => (
                      <div
                        key={"skel" + i}
                        className="rb-skeleton rb-skeleton--event"
                        aria-hidden="true"
                      />
                    ))}
                    <span className="rb-visually-hidden" role="status">
                      Loading matches
                    </span>
                  </>
                ) : cricket.length > 0 ? (
                  cricket
                    .filter((item) => {
                      const market = marketMap[item.marketId];

                      if (!matchesFilter(item, timeFilter, teamQuery)) return false;

                      return (
                        market &&
                        market.runners?.some(
                          runner =>
                            runner?.ex?.availableToBack?.length > 0 ||
                            runner?.ex?.availableToLay?.length > 0
                        )
                      );
                    }).map((item, index) => {
                      const market = marketMap[item.marketId];

                      const runner1 = market?.runners?.[0];
                      const runner2 = market?.runners?.[1];

                      const r1Back = runner1?.ex?.availableToBack?.[0]?.price;
                      const r1Lay = runner1?.ex?.availableToLay?.[0]?.price;

                      const r2Back = runner2?.ex?.availableToBack?.[0]?.price;
                      const r2Lay = runner2?.ex?.availableToLay?.[0]?.price;


                      const marketData = market?.runners || [];

                      return (
                        <div
                          key={index}
                          _ngcontent-jrx-c94=""
                          id={item?.competition?.id}
                          className="rb-event"
                          style={{ position: "relative" }}
                        >
                          <EventCard
                            item={item}
                            marketData={marketData}
                            onOpen={handleClick}
                          />
                          {/* betting back div */}
                          {backActive === 1 &&
                            side === "Back" &&
                            (
                              <div
                                style={{
                                  backgroundColor: "#052e36",
                                  padding: "15px",
                                  color: "white",
                                  borderRadius: "5px",
                                  width: "100%",
                                }}
                                className="homebet"
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "15px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor: "#0A6E8A",
                                      color: "white",
                                      padding: "8px 20px",
                                      border: "none",
                                      borderRadius: "5px",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() => {
                                      setbackActive(0);
                                      setMoney(0);
                                      setPr(0);
                                    }}
                                  >
                                    BACK
                                  </button>
                                  <div
                                    style={{
                                      color: "#4ADE80",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Profit:{" "}
                                    {(money * (selectedPrice - 1)).toFixed(1)}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                        marginRight: "8px",
                                      }}
                                      id="matchAtAnyRate"
                                    />
                                    <label htmlFor="matchAtAnyRate">
                                      Match At Any Rate
                                    </label>
                                  </div>
                                </div>

                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "10px",
                                    marginBottom: "15px",
                                  }}
                                >
                                  <div className="w-25" style={{ flex: 1 }}>
                                    <div
                                      style={{
                                        textAlign: "center",
                                        marginBottom: "5px",
                                      }}
                                    >
                                      Odds
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        height: "40px",
                                      }}
                                    >
                                      <button
                                        style={{
                                          backgroundColor: "#064150",
                                          color: "white",
                                          width: "40px",
                                          border: "none",
                                          fontSize: "20px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          borderRadius: "4px 0 0 4px",
                                        }}
                                        onClick={() => handlelayChange(0)}
                                      >
                                        −
                                      </button>
                                      <input
                                        type="text"
                                        value={selectedPrice}
                                        onChange={(e) =>
                                          setSelectedPrice(e.target.value)
                                        }
                                        style={{
                                          backgroundColor: "#064150",
                                          color: "white",
                                          border: "none",
                                          flex: 1,
                                          textAlign: "center",
                                          fontSize: "18px",
                                          width: "10px",
                                        }}
                                      />
                                      <button
                                        style={{
                                          backgroundColor: "#064150",
                                          color: "white",
                                          width: "40px",
                                          border: "none",
                                          fontSize: "20px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          borderRadius: "0 4px 4px 0",
                                        }}
                                        onClick={() => handlelayChange(1)}
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>
                                  <div className="w-25" style={{ flex: 1 }}>
                                    <div
                                      style={{
                                        textAlign: "center",
                                        marginBottom: "5px",
                                      }}
                                    >
                                      Stake
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        height: "40px",
                                      }}
                                    >
                                      <button
                                        style={{
                                          backgroundColor: "#064150",
                                          color: "white",
                                          width: "40px",
                                          border: "none",
                                          fontSize: "20px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          borderRadius: "4px 0 0 4px",
                                        }}
                                        onClick={() => handleChange(0)}
                                      >
                                        −
                                      </button>
                                      <input
                                        type="text"
                                        value={money}
                                        onChange={(e) =>
                                          setMoney(e.target.value)
                                        }
                                        style={{
                                          backgroundColor: "#064150",
                                          color: "white",
                                          border: "none",
                                          flex: 1,
                                          textAlign: "center",
                                          fontSize: "18px",
                                          width: "10px",
                                        }}
                                      />
                                      <button
                                        style={{
                                          backgroundColor: "#064150",
                                          color: "white",
                                          width: "40px",
                                          border: "none",
                                          fontSize: "20px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          borderRadius: "0 4px 4px 0",
                                        }}
                                        onClick={() => handleChange(1)}
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(4, 1fr)",
                                    gap: "8px",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor: "#064150",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(100)}
                                  >
                                    + 100
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#064150",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(200)}
                                  >
                                    + 200
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#064150",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(500)}
                                  >
                                    + 500
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#064150",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(1000)}
                                  >
                                    + 1k
                                  </button>
                                </div>

                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(4, 1fr)",
                                    gap: "8px",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor: "#064150",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(5000)}
                                  >
                                    + 5k
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#064150",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(10000)}
                                  >
                                    + 10k
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#064150",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(25000)}
                                  >
                                    + 25k
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#064150",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(50000)}
                                  >
                                    + 50k
                                  </button>
                                </div>

                                {/* <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(4, 1fr)",
                                    gap: "8px",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor: "#166534",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Min
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#1e3a8a",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Max
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#7e22ce",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Edit Stake
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#991b1b",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() => {
                                      setMoney(0);
                                      setPr(0);
                                    }}
                                  >
                                    Clear
                                  </button>
                                </div> */}

                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(2, 1fr)",
                                    gap: "8px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor: "#ef4444",
                                      color: "white",
                                      padding: "12px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() => {
                                      setbackActive(0);
                                      setMoney(0);
                                      setPr(0);
                                    }}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#22c55e",
                                      color: "white",
                                      padding: "12px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() => handleSubmit()}
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            )}

                          {/* betting lay div */}
                          {layActive === 1 &&
                            side === "Lay" &&
                            (
                              <div
                                style={{
                                  backgroundColor: "rgb(247 150 255 / 40%)",
                                  padding: "15px",
                                  color: "white",
                                  borderRadius: "5px",
                                  width: "100%",
                                }}
                                className="homebet"
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "15px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor: "rgb(247 150 255 / 60%)",
                                      color: "white",
                                      padding: "8px 20px",
                                      border: "none",
                                      borderRadius: "5px",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() => {
                                      setbackActive(0);
                                      setMoney(0);
                                      setPr(0);
                                    }}
                                  >
                                    Lay
                                  </button>
                                  <div
                                    style={{
                                      color: "#4ADE80",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Profit:{" "}
                                    {(money * (selectedPrice - 1)).toFixed(1)}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                        marginRight: "8px",
                                      }}
                                      id="matchAtAnyRate"
                                    />
                                    <label htmlFor="matchAtAnyRate">
                                      Match At Any Rate
                                    </label>
                                  </div>
                                </div>

                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "10px",
                                    marginBottom: "15px",
                                  }}
                                >
                                  <div style={{ flex: 1 }}>
                                    <div
                                      style={{
                                        textAlign: "center",
                                        marginBottom: "5px",
                                      }}
                                    >
                                      Odds
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        height: "40px",
                                      }}
                                    >
                                      <button
                                        style={{
                                          backgroundColor: "rgb(247 150 255 / 60%)",
                                          color: "white",
                                          width: "40px",
                                          border: "none",
                                          fontSize: "20px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          borderRadius: "4px 0 0 4px",
                                        }}
                                        onClick={() => handlelayChange(0)}
                                      >
                                        −
                                      </button>
                                      <input
                                        type="text"
                                        value={selectedPrice}
                                        onChange={(e) =>
                                          setSelectedPrice(e.target.value)
                                        }
                                        style={{
                                          backgroundColor: "rgb(247 150 255 / 60%)",
                                          color: "white",
                                          border: "none",
                                          flex: 1,
                                          textAlign: "center",
                                          fontSize: "18px",
                                          width: "10px",
                                        }}
                                      />
                                      <button
                                        style={{
                                          backgroundColor: "rgb(247 150 255 / 60%)",
                                          color: "white",
                                          width: "40px",
                                          border: "none",
                                          fontSize: "20px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          borderRadius: "0 4px 4px 0",
                                        }}
                                        onClick={() => handlelayChange(1)}
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>
                                  <div style={{ flex: 1 }}>
                                    <div
                                      style={{
                                        textAlign: "center",
                                        marginBottom: "5px",
                                      }}
                                    >
                                      Stake
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        height: "40px",
                                      }}
                                    >
                                      <button
                                        style={{
                                          backgroundColor: "rgb(247 150 255 / 60%)",
                                          color: "white",
                                          width: "40px",
                                          border: "none",
                                          fontSize: "20px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          borderRadius: "4px 0 0 4px",
                                        }}
                                        onClick={() => handleChange(0)}
                                      >
                                        −
                                      </button>
                                      <input
                                        type="text"
                                        value={money}
                                        onChange={(e) =>
                                          setMoney(e.target.value)
                                        }
                                        style={{
                                          backgroundColor: "rgb(247 150 255 / 60%)",
                                          color: "white",
                                          border: "none",
                                          flex: 1,
                                          textAlign: "center",
                                          fontSize: "18px",
                                          width: "10px",
                                        }}
                                      />
                                      <button
                                        style={{
                                          backgroundColor: "rgb(247 150 255 / 60%)",
                                          color: "white",
                                          width: "40px",
                                          border: "none",
                                          fontSize: "20px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          borderRadius: "0 4px 4px 0",
                                        }}
                                        onClick={() => handleChange(1)}
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(4, 1fr)",
                                    gap: "8px",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor: "rgb(247 150 255 / 60%)",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(100)}
                                  >
                                    + 100
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "rgb(247 150 255 / 60%)",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(200)}
                                  >
                                    + 200
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "rgb(247 150 255 / 60%)",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(500)}
                                  >
                                    + 500
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "rgb(247 150 255 / 60%)",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(1000)}
                                  >
                                    + 1k
                                  </button>
                                </div>

                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(4, 1fr)",
                                    gap: "8px",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor: "rgb(247 150 255 / 60%)",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(5000)}
                                  >
                                    + 5k
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "rgb(247 150 255 / 60%)",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(10000)}
                                  >
                                    + 10k
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "rgb(247 150 255 / 60%)",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(25000)}
                                  >
                                    + 25k
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "rgb(247 150 255 / 60%)",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(50000)}
                                  >
                                    + 50k
                                  </button>
                                </div>

                                {/* <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(4, 1fr)",
                                    gap: "8px",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor: "#166534",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Min
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#1e3a8a",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Max
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#7e22ce",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Edit Stake
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#991b1b",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() => {
                                      setMoney(0);
                                      setPr(0);
                                    }}
                                  >
                                    Clear
                                  </button>
                                </div> */}

                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(2, 1fr)",
                                    gap: "8px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor: "#ef4444",
                                      color: "white",
                                      padding: "12px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() => {
                                      setlayActive(0);
                                      setMoney(0);
                                      setPr(0);
                                    }}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#22c55e",
                                      color: "white",
                                      padding: "12px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() => handleSubmit()}
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            )}
                        </div>
                      );
                    })
                ) : (
                  <div className="rb-empty">
                    <span className="rb-empty__icon" aria-hidden="true">
                      <i className="fa fa-calendar-xmark" />
                    </span>
                    <span className="rb-empty__title">No matches to show</span>
                    <span className="rb-empty__body">
                      {teamQuery || timeFilter !== "all"
                        ? "Nothing matches that filter right now. Try All, or clear the search."
                        : "There are no priced markets here at the moment. Check back shortly."}
                    </span>
                    {(teamQuery || timeFilter !== "all") && (
                      <button
                        type="button"
                        className="rb-btn rb-btn--secondary rb-btn--sm"
                        onClick={() => {
                          setTeamQuery("");
                          setTimeFilter("all");
                        }}
                      >
                        Clear filters
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};



const CricketReal = () => {
  const [isSidebar, setSidebar] = useState(false);
  const [isInplay, setInplay] = useState(true);
  const [isTomorrow, setTomorrow] = useState(false);
  const [isUpcoming, setUpcoming] = useState(false);
  const [isActive, setActiveLink] = useState(0);
  const { themeColors } = useTheme();

  const [showCanvas, setShowCanvas] = useState(false);

  const handleCanvasShow = () => setShowCanvas(true);
  const handleCanvasClose = () => setShowCanvas(false);


  const handlePlay = (id) => {
    setInplay(false);
    setTomorrow(false);
    setUpcoming(false);

    if (id === "inplay") {
      setInplay(true);

    } else if (id === "tomorrow") {
      setTomorrow(true);

    } else {
      setUpcoming(true);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleResize = () => {
      // Start closed and let the visitor open it. Forcing it open
      // above 991px put a fixed panel over the page content.
      setSidebar(false);
    };
    handleResize();
  }, []);

  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 991);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 991);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);



  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16" >

      <div _ngcontent-jrx-c101="">
        <app-toasts
          _ngcontent-jrx-c101=""
          aria-live="polite"
          aria-atomic="true"
          className="ngb-toasts"
        ></app-toasts>
        <router-outlet _ngcontent-jrx-c101=""></router-outlet>
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">

            {/* {isLargeScreen && <TopBar />} */}
            <Header isSidebar={isSidebar} setSidebar={setSidebar} show={showCanvas} handleShow={handleCanvasShow} handleClose={handleCanvasClose} />

            <div _ngcontent-jrx-c95="" className="body-container mb-5">
              <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  paddingLeft: isLargeScreen ? "0px" : '0px',
                  width: isSidebar ? "" : "1100%",
                  transition: "width 0.3s ease-in-out",
                  backgroundColor: 'var(--dark-theme-data-bg)',
                }}
              >

                <app-upcoming
                  _ngcontent-jrx-c95=""
                  _nghost-jrx-c94=""
                  className="ng-star-inserted"
                  style={{ backgroundColor: "white !important" }}
                >
                  {/* <div>
                    <img src="https://images.staticcontent.io/banners/desktop_banner_2.jpg" style={{ height: isLargeScreen ? 'auto' : '150px' }} className="img-fluid" />
                  </div> */}

                  {isInplay && <Inplay data={isActive} />}
                  {/* {isTomorrow && <Tomorrow data={isActive} />}
                  {isUpcoming && <Upcoming data={isActive} />} */}
                </app-upcoming>



                {/* <Footer /> */}
              </div>
            </div>
            <MarqueeBottom onMenuClick={handleCanvasShow} />
          </div>
        </app-landing-page-new>


        <div className="slider-container"></div>
      </div>
    </app-root>
  );
};


export default CricketReal;